import { Locale } from "@linkfluence/models/locale";
import { Occupation } from "@radarly/models/occupations";
import { RadarlyAPI } from "./base";

export class OccupationsAPI extends RadarlyAPI {
  public async getOccupations(ids: Array<Occupation["id"]>, locale: Locale) {
    return await this.post<Occupation[]>("/occupations.json", { locale, ids });
  }
}
